import React from 'react';
import { WalletContext } from '../context/wallet';

function useWallet() {
    const value = React.useContext(WalletContext);
    if (!value) {
        throw new Error("WalletContext's value is undefined.");
    }

    return value;
}

export { useWallet };
